import React, { useState, useEffect, useRef } from 'react';
import { chevronLeft, chevronRight } from "../../assets";

function isFloat(n){
    return Number(n) === n && n % 1 !== 0;
}

function getPoints(current, children, nbElements, setCurrent)
{
    let res = [];
    let nbPoints = Math.floor(children.length / nbElements);
    if (isFloat(children.length / nbElements))
        nbPoints++;
    for (let i = 0; i < nbPoints; i++)
        res.push(<span className= {Math.floor(current / nbElements) === i ? "active point" : "point"}  key={i} onClick={() => setCurrent(i * nbElements)}></span>);
    return (<>{nbPoints > 1 && res}</>);
}

function Carousel({ children, nbElements, chevronsOn, pointsOn, timer }) {
    const [current, setCurrent] = useState(0);
    const [animate, setAnimate] = useState(true);
    const interval = useRef();
    let elements = [];
    useEffect(() => {
        if (!isNaN(Number(timer)) && Number(timer) > 0)
        {
            interval.current = setInterval(() => {
                if (animate)
                {
                    if (current + nbElements >= children.length)
                        setCurrent((current + nbElements) - children.length);
                    else
                        setCurrent(current + nbElements);
                }
            }, (timer * 1000));
            return () => clearInterval(interval.current);
        }
    }, [current, animate]);

    if (nbElements > children.length)
        nbElements = children.length;
    else if (nbElements < 0)
        nbElements = 1;
    for (let i = current; i < (current + nbElements); i++)
    {
        let j = (i >= children.length) ? i - children.length : Math.abs(i);
        elements.push(children[j]);
    }
    return (
        <div id="carousel">
            <div className="main__view">
                {chevronsOn && <img src={chevronLeft} alt="left" className="chev" onClick={() => setCurrent(current - nbElements < 0 ? children.length - Math.abs(current - nbElements) : current - nbElements)}/>}
                <div className="slide" onMouseOut={() => setAnimate(true)} onMouseOver={() => setAnimate(false)}>
                    {elements.map((e) => e)}
                </div>
                {chevronsOn && <img src={chevronRight} alt="right" className="chev" onClick={() => setCurrent(current + nbElements >= children.length ? (current + nbElements) - children.length : current + nbElements)}/>}
            </div>
            <nav>
                {pointsOn && getPoints(current, children, nbElements, setCurrent)}
            </nav>
        </div>
    )
}

Carousel.defaultProps = {
    chevronsOn: true,
    pointsOn: true,
    nbElements: 2,
    timer: 4
}
export default Carousel
